module.exports = __webpack_public_path__ + "img/hr-wooden-particle-12.50508a77.png";